function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { MenuList, MenuListItem, MenuLink } from './partials/MenuList';
import { userMenu } from './data';
export const UserMenu = _ref => {
  let {
    user,
    mobile,
    finectApp,
    onItemClick
  } = _ref;
  return React.createElement(MenuList, {
    mobile: mobile
  }, React.createElement(Fragment, null, userMenu.items.map((_ref2, index) => {
    let {
      icon: Icon,
      text,
      href,
      app,
      lastOfGroup
    } = _ref2;
    const link = typeof href === 'function' ? href({
      user
    }) : href;
    const linkProps = finectApp === app ? {
      to: link,
      as: Link
    } : {
      href: link
    };
    const isLast = typeof lastOfGroup === 'function' ? lastOfGroup({
      user
    }) : lastOfGroup || false;
    if (!link) {
      return null;
    }
    return React.createElement(MenuListItem, {
      key: index,
      lastOfGroup: isLast
    }, React.createElement(Icon, {
      size: "24"
    }), React.createElement(MenuLink, _extends({
      "data-fi-event": "omninav-userMenu",
      onClick: () => {
        onItemClick && onItemClick();
      }
    }, linkProps), text));
  }).filter(item => Boolean(item))));
};